// Internal
import { store } from "src/redux/store";

// Types
import { Permissions as P } from "src/@types/permissions";

// enableStandardization: AccountClass -> DocumentClass -> [view, update]
const CLASS_PERMISSIONS: Record<string, Record<string, [P, P]>> = {
  AccountPayable: {
    Invoice: [P.AP_INVOICE_VIEW, P.AP_INVOICE_UPDATE],
    DeliveryNote: [P.AP_DELIVERYNOTE_VIEW, P.AP_DELIVERYNOTE_UPDATE],
    PurchaseOrder: [
      P.Procurement_PurchaseOrder_View,
      P.Procurement_PurchaseOrder_Update,
    ],
  },
  AccountReceivable: {
    Invoice: [P.AR_INVOICE_VIEW, P.AR_INVOICE_UPDATE],
    Order: [P.AR_ORDER_VIEW, P.AR_ORDER_UPDATE],
    DeliveryNote: [P.AR_DELIVERYNOTE_VIEW, P.AR_DELIVERYNOTE_UPDATE],
  },
};

export const isStandardizationOn = (): boolean =>
  Boolean(store.getState()?.organization?.org?.enableStandardization);

const getClassPermissions = (
  accountClass?: string | null,
  documentClass?: string | null,
) =>
  isStandardizationOn() && accountClass && documentClass
    ? CLASS_PERMISSIONS[accountClass]?.[documentClass]
    : undefined;

// Standardization off, unclassified or unmapped classes keep Documents_Read/Write.
export const getStandardReadPermissions = (
  accountClass?: string | null,
  documentClass?: string | null,
): P[] =>
  getClassPermissions(accountClass, documentClass) ?? [
    P.Documents_Read,
    P.Documents_Write,
  ];

export const getStandardWritePermissions = (
  accountClass?: string | null,
  documentClass?: string | null,
): P[] => {
  const permissions = getClassPermissions(accountClass, documentClass);
  return permissions ? [permissions[1]] : [P.Documents_Write];
};

// AP/AR class permissions only exist with standardization (POs reuse Procurement_*)
const STANDARD_ONLY_PERMISSIONS: string[] = Object.values(CLASS_PERMISSIONS)
  .flatMap((classes) => Object.values(classes).flat())
  .filter((permission) => !permission.startsWith("Procurement_"));

export const isPermissionHiddenByStandardization = (permission: string) =>
  !isStandardizationOn() && STANDARD_ONLY_PERMISSIONS.includes(permission);
